module.exports = __webpack_public_path__ + "img/logo.9d238de0.png";